import React, { useContext } from 'react';
import DndAnswerContext from 'components/common/Context';
import TextToSpeechButton from '@/components/shared/TextToSpeechButton';
import styles from './DraggableChoicesBank.module.scss';

interface QuestionBodyProps {
  ttsEnabled: boolean;
}

const QuestionBody = ({ ttsEnabled }: QuestionBodyProps) => {
  const {
    locale,
    questionId,
    questionBody,
  } = useContext(DndAnswerContext);

  return (
    <div className={styles.questionBody}>
      <label htmlFor={`question_${questionId}`}>
        <span
          className="respect_breaks"
          dangerouslySetInnerHTML={{ __html: questionBody }}
        />
      </label>
      {ttsEnabled && (
        <div className="inline">
          <TextToSpeechButton
            idToRead={`question_${questionId}_body`}
            locale={locale}
          />
        </div>
      )}
    </div>
  );
};

export default QuestionBody;
